import { writable } from 'svelte/store';
import { isCustomCssActive, isRetinaDisplay } from './utils';

export const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
export const navigation = writable({});
export const pages = writable([{id: 0, path: '/', scrollTop: 0}]);

// could later be extended to fetch other grav-content for specific urls
export const redirectToHome = [
	{ path: '/qr' }
];
export const history = writable([location.pathname]);
export const cookiesActivated = writable(localStorage.getItem('b1-cookies'));
export const useCustomCss = writable(isCustomCssActive());
export const showCustomCssButton = writable(true);
export const forceCustomCss = writable(false);
export const customCssButtonTextOff = writable('Kundenfarbwelt');
export const customCssButtonTextOn = writable('Kundenfarbwelt');
export const customCss = writable('');
export const animatePages = writable(false);

// rtl -> right to left = bring in unknown, new Page
// ltr -> left to right = bring back known Page
export const pagesDirection = writable('rtl');

// multiJump means the Page was visited lately but is not the directly previous Page
export const pagesMultiJump = writable(false);
export const userNavigated = writable(false);
export const previousUrl = writable(location.pathname);

export const apiUrl = ENV_API_URL || 'http://127.0.0.1:8000';
export const topNavigationVisible = writable(false);
export const topNavigationWidth = writable(0);
export const isRetina = writable(isRetinaDisplay());
export const textJSON = writable({});
export const files = writable({});
